import { render, staticRenderFns } from "./TerraIndexDynamicTable.vue?vue&type=template&id=3be06489"
import script from "./TerraIndexDynamicTable.vue?vue&type=script&lang=js"
export * from "./TerraIndexDynamicTable.vue?vue&type=script&lang=js"
import style0 from "./TerraIndexDynamicTable.vue?vue&type=style&index=0&id=3be06489&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports